export default "/static/webpack/media/spinner.816740ad.svg";